var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganizationsPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 81,
    viewBox: "0 0 107 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7380_69415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44859 33.1245C1.06388 31.6887 1.26528 30.1589 2.00848 28.8717C2.75168 27.5844 3.97581 26.6451 5.41156 26.2604L40.7798 16.7835C42.2156 16.3988 43.7454 16.6002 45.0326 17.3434C46.3199 18.0866 47.2592 19.3107 47.6439 20.7465L57.1208 56.1147C57.5055 57.5505 57.3041 59.0803 56.5609 60.3675C55.8177 61.6548 54.5936 62.5941 53.1578 62.9788L17.7896 72.4557C16.3538 72.8404 14.824 72.639 13.5368 71.8958C12.2495 71.1526 11.3102 69.9285 10.9255 68.4927L1.44859 33.1245Z",
    fill: "#AE9AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5596,
    cy: 44.563,
    r: 11.0713,
    transform: "rotate(-15 31.5596 44.563)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6941 33.8689C22.791 35.4506 19.2837 41.5253 20.8655 47.4285C22.4472 53.3316 28.5219 56.8388 34.425 55.2571C40.3282 53.6753 43.8354 47.6007 42.2537 41.6975C40.6719 35.7944 34.5972 32.2872 28.6941 33.8689ZM32.7623 53.3341C28.3977 53.942 24.1732 51.2227 23.0041 46.8596C22.8265 46.1965 22.743 45.5426 22.7158 44.8851L29.2108 48.635L29.4974 49.7045C29.8126 50.8808 31.0329 51.5854 32.2093 51.2702L32.7623 53.3341ZM39.4122 48.6407C38.902 47.849 37.9445 47.4408 36.982 47.6986L35.9126 47.9852L35.053 44.777C34.8954 44.1888 34.2852 43.8365 33.697 43.9941L27.2805 45.7134L26.7074 43.5746L28.8463 43.0015C29.4344 42.8439 29.7867 42.2337 29.6291 41.6455L29.056 39.5067L31.1949 38.9336C32.3712 38.6184 33.0758 37.398 32.7606 36.2217L32.6431 35.7832C36.1175 36.2162 39.1535 38.6923 40.1135 42.2748C40.7095 44.4992 40.3955 46.7496 39.4122 48.6407Z",
    fill: "#222222"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_7380_69415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6334 16.9057C49.0181 15.4699 49.9574 14.2458 51.2447 13.5026C52.532 12.7594 54.0617 12.558 55.4975 12.9427L90.8658 22.4196C92.3015 22.8043 93.5257 23.7437 94.2689 25.0309C95.0121 26.3182 95.2135 27.8479 94.8288 29.2837L85.3518 64.652C84.9671 66.0877 84.0278 67.3119 82.7406 68.0551C81.4533 68.7983 79.9235 68.9997 78.4878 68.615L43.1195 59.138C41.6837 58.7533 40.4596 57.814 39.7164 56.5268C38.9732 55.2395 38.7718 53.7097 39.1565 52.274L48.6334 16.9057Z",
    fill: "#C4B6FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0665 33.2889L65.1685 36.6403L61.817 35.7423C60.2932 35.334 58.7269 36.2383 58.3186 37.7621C57.9103 39.2859 58.8146 40.8522 60.3384 41.2605L63.6899 42.1586L62.7919 45.51C62.3835 47.0338 63.2879 48.6001 64.8117 49.0084C66.3355 49.4167 67.9018 48.5124 68.3101 46.9886L69.2081 43.6372L72.5596 44.5352C74.0834 44.9435 75.6497 44.0392 76.058 42.5154C76.4663 40.9916 75.562 39.4253 74.0382 39.017L70.6867 38.1189L71.5847 34.7675C71.993 33.2437 71.0887 31.6774 69.5649 31.2691C68.0411 30.8608 66.4748 31.7651 66.0665 33.2889Z",
    fill: "#222222",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_7380_69415",
    x: 33.9658,
    y: 8.75,
    width: 66.0537,
    height: 66.0547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7380_69415"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7380_69415",
    result: "effect2_dropShadow_7380_69415"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_7380_69415",
    result: "effect3_dropShadow_7380_69415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_7380_69415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7380_69415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.8249,
    height: 47.8249,
    fill: "white",
    transform: "translate(-0.00195312 27.7109) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationsPlaceholder);
export default __webpack_public_path__ + "static/media/organizations-placeholder.6ff8e4b46b2319d89acc472558dc31c2.svg";
export { ForwardRef as ReactComponent };